import { Controller } from '@hotwired/stimulus';
import Plotly from 'plotly.js-dist';
import nl_locale from 'plotly.js-locales/nl'

export default class extends Controller {
  static values = {
    config: Object,
  };

  connect() {
    const { config, data, layout } = this.configValue;

    if (config.locale === 'nl') {
      Plotly.register(nl_locale);
    }

    this.originalData = data;
    this.originalLayout = layout;
    this.plotConfig = config;
    this.darkModeQuery = window.matchMedia('(prefers-color-scheme: dark)');

    Plotly
      .newPlot(this.element, this.themedData(), this.themedLayout(), config)
      .then(() => {
        this.element.on('plotly_click', this.handleClick.bind(this))
      });

    this.onDarkModeChange = () => {
      Plotly.react(this.element, this.themedData(), this.themedLayout(), this.plotConfig);
    };
    this.darkModeQuery.addEventListener('change', this.onDarkModeChange);
  }

  disconnect() {
    this.darkModeQuery?.removeEventListener('change', this.onDarkModeChange);
  }

  themedLayout() {
    const textColor = this.cssColor('--color-text-primary');
    const elevateColor = this.cssColor('--color-fill-elevate');
    const gridColor = this.cssColor('--color-border-secondary');

    const themed = {
      ...this.originalLayout,
      paper_bgcolor: 'transparent',
      plot_bgcolor: 'transparent',
      font: {
        ...this.originalLayout.font,
        color: textColor,
      },
      hoverlabel: {
        ...this.originalLayout.hoverlabel,
        bgcolor: elevateColor,
        font: { ...this.originalLayout.hoverlabel?.font, color: textColor },
      },
    };

    for (const key of Object.keys(themed)) {
      if (key.startsWith('xaxis') || key.startsWith('yaxis')) {
        themed[key] = { ...themed[key], gridcolor: gridColor };
      }
    }

    return themed;
  }

  themedData() {
    const isDark = this.darkModeQuery.matches;

    return this.originalData.map(trace => {
      if (!isDark) return trace;

      const themed = { ...trace };

      if (trace.line?.darkColor) {
        themed.line = { ...trace.line, color: trace.line.darkColor };
      }
      if (trace.marker?.darkColor) {
        themed.marker = { ...trace.marker, color: trace.marker.darkColor };
      }

      return themed;
    });
  }

  cssColor(property) {
    return getComputedStyle(document.documentElement).getPropertyValue(property).trim();
  }

  handleClick(event) {
    const detail = { plotly: event }
    const customEvent = new CustomEvent('plotly_click', { detail, bubbles: true });
    this.element.dispatchEvent(customEvent);
  }
}
